<template>
  <component
    :is="LocalIcon"
    :class="['e-icon', { [`size-${size}`]: size }]"
    @click="onClick"
    v-if="LocalIcon"
  /><component
    :is="RenderedIcon"
    :class="['e-icon', { [`size-${size}`]: size }]"
    @click="onClick"
    v-else-if="RenderedIcon"
  />
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue';
import { renderSvg } from '@/utils/dom-utils';
import { camelCase, upperFirst } from 'lodash-es';
const props = defineProps({
  field: {
    type: Object,
  },
  svg: {
    type: String,
    default: null,
  },
  /**@type {String} [left|right]*/
  name: {
    type: String,
    required: false,
  },
  size: {
    type: String,
    default: null,
  },
});
const emit = defineEmits(['click']);
const RenderedIcon = computed(() => {
  const code = props.svg ?? props.field?.value?.svgCode ?? props.field?.value?.alt;
  if (code && typeof code === 'string' && code.trim() !== '') {
    return renderSvg(code);
  }
  return null;
});
const localIconName = computed(() => {
  if (!props.name) return null;

  const normalized = upperFirst(camelCase(props.name));
  return normalized ? `Icon${normalized}` : null;
});

const LocalIcon = computed(() => {
  if (!localIconName.value) return null;

  return defineAsyncComponent(() => import(`@/icons/${localIconName.value}.vue`));
});
const onClick = (e) => {
  emit('click', e);
};
</script>

<style lang="scss">
@import '../styles/variables';
@import '../styles/mixins';
.e-icon {
  display: inline-block;
  fill: currentColor;
  height: auto;
  font-size: 0;
  letter-spacing: -3px;
  vertical-align: middle;
  &.size- {
    &xxs {
      width: 16px;
    }
    &xs {
      width: 24px;
    }
    &s {
      width: 32px;
    }
    &m {
      width: 48px;
    }
    &l {
      width: 64px;
    }
    &xl {
      width: 96px;
    }
    &auto {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
